import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class GetSurveyListAdmin extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/survey/SurveyPublishList',
      requesterInfo,
    })
  }

  public async getSurveyListAdmin(): Promise<any[]> {
    return await this.getAsync<any[]>()
  }
}
